// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/takeoff-clearance-modifiers.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/takeoff-clearance-modifiers/takeoff-clearance-modifiers.js';

mount([g0]);
